import suid from '../suid';
import EventEmitter from 'events';

export const MD_MSG = 'msg';
export const MD_BUTTON_OK = 'ok';

export const modalHelperFactory = ({ setValue, path }) => {
    const _modalStack = [];
    const _eventEmitter = new EventEmitter();

    const _notifyChange = () => {
        if (setValue) {
            const currentModals = _modalStack.reduce((accum, record) => {
                const { type, id } = record;

                accum.push({ type, id });

                return accum;
            }, []);

            setValue({ path: `${path}.currentModals`, value: currentModals });
        }
        _eventEmitter.emit('change');
    };

    const _removeModal = (idToRemove) => {
        const index = _modalStack.findIndex(({ id }) => id === idToRemove);

        if (index !== -1) {
            _modalStack.splice(index, 1);
        }
        _notifyChange();
    };

    const aShowModal = ({ type, params = {} }) =>
        new Promise((resolve) => {
            const id = suid();
            const newModal = {
                type,
                params,
                id,
                handleClose: (result) => {
                    _removeModal(id);
                    resolve(result);
                },
            };

            _modalStack.push(newModal);
            _notifyChange();
        });

    const getCurrentModal = () => {
        if (!_modalStack || !_modalStack.length) {
            return {};
        }

        const currentModal = _modalStack[_modalStack.length - 1];

        return currentModal;
    };

    const on = (eventName, handler) => {
        _eventEmitter.on(eventName, handler);
    };

    const off = (eventName, handler) => {
        _eventEmitter.off(eventName, handler);
    };

    const once = (eventName, handler) => {
        _eventEmitter.once(eventName, handler);
    };

    return {
        aShowModal,
        getCurrentModal,
        on,
        off,
        once,
    };
};

export default modalHelperFactory;
